import { TipBox } from "./TipBox.js";
import { html, render } from "lit-html";
import CreateWindow from "../puzzles/puzzleWindow";
import "./index.css";
import { stopPhones } from "../helpers/checkGlow.js";
import { DistanceConstraint } from "cannon";
import { pickText } from "../textcontents.js";
export let tipData = {};

let showTips = false;

export const checkIfShowingTips = () => {
  let filtered = Object.keys(tipData).filter((e) => tipData[e].showing);
  return filtered.length === 0 ? false : filtered.map((e) => tipData[e]);
};
let puzzleWindow;
let exit;
export const TipWindow = function () {
  const d = CreateWindow({
    blurred: true,
    removeContainer: true,
    exitCallback: () => {
      //   (puzzleWindow = null)
      document.body.classList.remove("hideImages")
    },
  })

  puzzleWindow = d.element
  exit = d.exit

  
  const markup = html`
    <div class="show-tip-container">
      ${(() => {
        const showingTips = checkIfShowingTips();
        if (!showingTips) {
          return html`<p>${pickText("tips", "noTips")}</p>`;
        } else {
          stopPhones.stop();
          document.querySelector(".puhelin-ikoni").style.display = "none";
          /*           if (!showTips) {
            return html`<div class="do-you-want-tips">
              <div>Sinulle on uusi vihje. Haluatko lukea sen?</div>
              <div class="tips-or-not-buttons">
                <div
                  @click=${() => {
                    showTips = true;
                    TipWindow();
                  }}
                >
                  Kyllä
                </div>
              </div>
            </div>`}; */

          for (let i = 0; i < showingTips.length; i++) {
            tipData[showingTips[i].name].opened = true;
          }
          return Object.keys(tipData).map((e) => {
            if (tipData[e].removed || !tipData[e].text) return;
            console.log(tipData[e])
            if (tipData[e].showOnlyOnce) {tipData[e].removed = true; tipData[e].showing = false};
            return html` <p>
              <i
                class="${tipData[e].errorIcon
                  ? "icon-error-alt"
                  : "icon-lightbulb"} animated bounceIn repeat-5"
              ></i>
              ${tipData[e].text}
            </p>`;
          });
        }
      })()}
    </div>
  `;

  if (tipData["safariPoster"] && tipData["safariPoster"].showing) {
    tips.safariPoster2.setTime(45);
    setTimeout(() => tips.safariPoster.clear(), 20000);
  }

  // CreateWindow palauttaa modaali-ikkunan noden, johon siis rendataan
  render(markup, puzzleWindow);
  document.body.classList.add("hideImages")
};

const tips = (() => {
  const create = (name, text, seconds, room, showOnlyOnce, override) => {
    if (
      (tipData[name] && tipData[name].created && !override) ||
      (tipData[name] && tipData[name].removed)
    )
      return;
    tipData[name] = {
      removed: false,
      created: true,
      room,
      showing: false,
      name: null,
      showOnlyOnce
    };

    console.log(
      `LUOTU ajastin ${seconds} tipsille ${name} huoneessa ${room}. Näytetään vain kerran ${showOnlyOnce}. Näytetty jo ${tipData[name] ? tipData[name].removed : false}. Override ${override ?? "ei"}`
    );

    if(tipData[name].timeout) {
    clearTimeout(tipData[name].timeout);
    }
    tipData[name].timeout = window.setTimeout(() => {
      tipData[name] = {
        text,
        name,
        room,
        showOnlyOnce,
        showing: true,
      };

      document.querySelector(".puhelin-ikoni").style.display = "initial";
      console.log(`TRIGATTU: tipsi ${name}`);
      if (false) TipBox(text, name, errorIcon);
    }, seconds * 1000);
  };

  const destroy = (name) => {
    if (tipData[name] && tipData[name].removed) return;
    else if (!tipData[name]) {
      // no set time has been called
      tipData[name] = {
        removed: true,
        showing: false,
        created: true,
      };

      console.log(`TUHOTTU: tipsi ${name}`);
    } else {
      console.log(`UNOHDETTU: tipsi ${name}`);
      //showTips = false;
      // set time has been called
      tipData[name].removed = true;
      tipData[name].showing = false;
      if (tipData[name].timeout) {
        clearTimeout(tipData[name].timeout);
      }
    }
  };

  const createTipBox = (text, tipId, errorIcon) => {
    tipData[tipId] = {
      text,
      tipId,
      created: true,
      removded: false,
    };
    TipBox({ text, tipId: "wallSwitchStuck", errorIcon });
  };

  const destroyTipBox = (tipId) => {
    return (
      tipData[tipId] && tipData[tipId].removeTip && tipData[tipId].removeTip()
    );
  };

  const createSingleTip = (name, text, room, showOnlyOnce) => {
    return {
      [name]: {
        setTime: (seconds, options) => {
          create(name, text, seconds, room, showOnlyOnce, options?.override);
        },
        retrieveData: () => {return tipData[name]},
        clear: () => destroy(name),
      },
    };
  };

  let tipTextData = [
    [
      "gameStarted",
      "flat",
      false
    ],
    [
      "matrixPoster",
      "flat",
      false
    ],
    [
      "solveMatrix",
      "flat",
      false
    ],
    ["goToTwitter",  "flat", false],
    [
      "twitterPassword",
      "flat",
      false
    ],
    ["twitterExplained",  "flat", true],
    [
      "lockConsole",
      "flat",
      false
    ],
    [
      "solveLockConsole",
      "flat",
      false
    ],
    ["magazine",  "warehouse", false],
    ["cameraLocker",  "warehouse", false],
    [
      "solveCameraLocker",
      "warehouse",
    ],
    ["camera", "warehouse"],
    [
      "solveClock1",
      "warehouse",
      false
    ],
    [
      "solveClock2",
      "warehouse",
      false
    ],
    [
      "bunkerFound",
      "bunker",
      false
    ],
    [
      "controlPanel",
      "bunker",
      false
    ],
    [
      "solveControlPanel1",
      "bunker",
      false
    ],
    [
      "solveControlPanel2",
      "bunker",
      false
    ],
    ["bunkerComputer",  "bunker", false],
    [
      "solveBunkerComputer",
      "bunker",
      false
    ],
    [
      "bunkerComputerWrong",
      "bunker",
      false
    ],
    ["warehouseComputer", "bunker", false],
    [
      "solveWarehouseComputer",
      "warehouse",
      false
    ],
    [
      "warehouseComputerWrong",
      "warehouse",
      false
    ],
    ["flatComputer",  "warehouse", false],
    [
      "solveFlatComputer",
      "flat",
      false
    ],
    [
      "flatComputerWrong",
      "flat",
      false
    ],
    [
      "safariPoster",
      "flat",
      false
    ],
    [
      "safariPoster2",
      "flat",
      false
    ],
    [
      "safariSwitch",
      "flat",
      false
    ],
  ];

  let tipList = {};

  tipTextData.forEach((e) => {
    tipList = { ...tipList, ...createSingleTip(e[0], pickText("tips", e[0]), e[1], e[2]) };
  });

  return {
    ...tipList,
  };
})();

const clearAllTips = () => {
  Object.keys(tipData).forEach(key => {
    tipData[key].removed = true;
    tipData[key].showing = false;
    if(tipData[key].timeout) {
    clearTimeout(tipData[key].timeout);
    }
  console.log("removed " + key)
  })
}

export { TipBox, tips, clearAllTips};
